import { FieldRegistry } from '../FieldRegistry';

FieldRegistry.register({
  type: 'hidden',
  renderInput: ({ value, onChange }) => (
    <input
      type="hidden"
      value={(value as string) ?? ''}
      onChange={(e) => onChange(e.target.value || null)}
    />
  ),
  renderCell: () => <span className="text-xs text-text-muted italic">ukryte</span>,
  validate: () => null,
  defaultValue: null,
});
